import { PropsWithChildren } from 'react';
import { validateOrderFormData } from '../../../lib/orderHelpers';
import { OrderSide } from '../../../types/generated';
import { ValidatedOrder } from '../../../types/orders';
import { Button } from '../../catalyst-ui-kit/button';
import { useOrderFormData } from '../hooks/useOrderFormData';

type PlaceOrderButtonProps = PropsWithChildren<{
  disabled: boolean;
  onClick: (orderData: ValidatedOrder) => void;
  signerExpired: boolean;
}>;

export const PlaceOrderButton: React.FC<PlaceOrderButtonProps> = ({
  children,
  disabled,
  onClick,
  signerExpired,
}) => {
  const orderFormData = useOrderFormData();
  const greenOrRed = OrderSide.BUY === orderFormData.side ? 'green' : 'red';
  return (
    <Button
      color={signerExpired ? 'blue' : greenOrRed}
      disabled={disabled}
      className="w-full cursor-pointer disabled:cursor-default"
      onClick={() => {
        const validatedOrder = validateOrderFormData(orderFormData);

        if (!validatedOrder) return;

        onClick(validatedOrder);
      }}
    >
      {children}
    </Button>
  );
};
